// AdminPanelLayout.jsx
import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';



const AdminPanelLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin-panel/login');
  };

  const menuItems = [
    { path: '/admin-panel/dashboard',                     label: 'Dashboard',                               icon: 'fa-house' },
    { path: '/admin-panel/activity-administrators',       label: 'Activity Campaign Managers / Administrators', icon: 'fa-people-roof' },
    { path: '/admin-panel/activity-participants',         label: 'Activity Influencers / Participants',     icon: 'fa-users' },
    { path: '/admin-panel/activity-individuals',          label: 'Activity Individuals',                   icon: 'fa-user-pen' },
    { path: '/admin-panel/donors-users',                  label: 'Donors',                                  icon: 'fa-hand-holding-dollar' },
    { path: '/admin-panel/withdraw-request',              label: 'Withdrawal Requests',                     icon: 'fa-money-bill-transfer' },
    { path: '/admin-panel/user',                          label: 'Users',                                   icon: 'fa-user-gear' },
    { path: '/admin-panel/ambassador-codes',              label: 'Ambassador Codes',                        icon: 'fa-user-check' },
    { path: '/admin-panel/salesperson',                   label: 'Salespersons',                            icon: 'fa-people-group' },
    { path: '/admin-panel/stripe/stripe-credential',      label: 'Stripe',                                  icon: 'fa-brands fa-stripe-s' },
    { path: '/admin-panel/reports/sales-reports',         label: 'Reports',                                 icon: 'fa-regular fa-file-lines' },
    { path: '/admin-panel/home/recent-campaigns',         label: 'Home',                                    icon: 'fa-house-chimney-user' },
  ];

  const isActive = (path) => {
    if (path === '/admin-panel/stripe/stripe-credential') return location.pathname.startsWith('/admin-panel/stripe');
    if (path === '/admin-panel/reports/sales-reports')    return location.pathname.startsWith('/admin-panel/reports');
    if (path === '/admin-panel/home/recent-campaigns')    return location.pathname.startsWith('/admin-panel/home');
    return location.pathname === path;
  };

  return (
    <div className="admin-panel-wrapper">
      {/* Header */}
      <header className="dashboard-header position-sticky top-0">
        <nav className="dashboard-navbar navbar navbar-expand-lg navbar-light px-md-4 py-1">
          <button
            className="dashboard-button navbar-toggler d-lg-none"
            type="button"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="d-flex justify-content-between align-items-center pe-3 pe-md-0 flex-grow-1">
            <Link className="navbar-brand" to="/admin-panel/dashboard">
              <img src="/images/logo_image.webp" alt="FundMeWiz" className="admin-dashboard-logo" />
            </Link>

            <div className="ms-lg-auto">
              <span className="nav-title d-none d-lg-block">ADMINISTRATION PANEL</span>
            </div>
          </div>
        </nav>
      </header>

      {/* Wrapper – same as original */}
      <div className="d-flex" id="wrapper">
        {/* Sidebar – matches original classes + mobile open state */}
        <div
          className={`bg-light border-right sidebar-wrapper ${sidebarOpen ? 'open' : ''}`}
          id="sidebar-wrapper"
        >
          <button
            className="close-btn d-block d-lg-none"
            onClick={() => setSidebarOpen(false)}
          >
            ×
          </button>

          <div className="list-group-context d-flex justify-content-between flex-column h-100">
            <div className="list-group list-group-flush">
              {/* Mobile-only title */}
              <div className="nav-date-responsive d-lg-none px-3 py-1">
                <div className="nav-title pb-2">ADMINISTRATION PANEL</div>
              </div>

              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`dashboard-list list-group-item-action ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => setSidebarOpen(false)}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title={item.label}
                >
                  <i className={`fa-solid ${item.icon} me-2`}></i>
                  <span className="d-lg-none d-xl-inline-block ps-2 text-wrap">{item.label}</span>
                </Link>
              ))}
            </div>

            {/* Logout at bottom */}
            <div className="dashboard-logout-container bg-light text-center">
              <button className="dashboard-logout mt-3" onClick={handleLogout}>
                <i className="fa-solid fa-right-from-bracket"></i>
                <span className="d-lg-none d-xl-inline-block ps-2">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
        {/* Main content */}
          <div className="dashboard-container">
            <Outlet />
          </div>
      {/* Mobile sidebar overlay / backdrop */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-lg-none show"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminPanelLayout;